import { createQueryKeys } from '@lukemorales/query-key-factory';

import type { FetchPublicPageAdminListArgs } from '../api/types/publicPageAdmin.types';

import { fetchPublicPageAdminList } from '../api/publicPageAdmin.api';

export const publicPageAdminQueryKeys = createQueryKeys('publicPageAdmin', {
  // Fix round 1, Finding 5: parameterized by offset/limit — each page is
  // its own cache entry, invalidated together via `._def`.
  fetchList: ({ offset, limit }: FetchPublicPageAdminListArgs) => ({
    queryFn: () => fetchPublicPageAdminList({ limit, offset }),
    queryKey: [offset, limit],
  }),
});
